import { useEffect, useState, useRef, useCallback } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";

import styles from "./Topbar.module.css"
import mylo_logo from "../../assets/images/logo.svg";
import mylo_yellow_logo from "../../assets/images/logo_yellow.svg";
import logo_ms from "../../assets/images/logo_ms.svg";
import logo_msw from "../../assets/images/logo_msw.svg";
import logo_mhw from "../../assets/images/logo_mhw.svg";
import logo_mtw from "../../assets/images/logo_mtw.svg";
import logo_mt from "../../assets/images/logo_mt.svg";
import logo_mh from "../../assets/images/logo_mh.svg";


const Topbar = ({ active }) => {
  	const [isSticky, setIsSticky] = useState(false);
  	const [showHamburger, setShowHamburger] = useState(false)
  	const outerRef = useRef(null);


  	useEffect(() => {
    	const handleScroll = () => {
      		if (outerRef.current) {
        		const top = outerRef.current.getBoundingClientRect().top;
        		setIsSticky(top <= 0);
      		}
    	};

    	window.addEventListener("scroll", handleScroll, { passive: true });
    	return () => window.removeEventListener("scroll", handleScroll);
  	}, []);

	const handleNavigate = (loc) => {
		window.location = `${loc}`
	}

	return (
		<>
			<div className={`${styles.topbar_outer}`} ref={outerRef}>
				<div className={`${styles.topbar_container} ${isSticky && styles.sticky}`}>
					<div className={styles.topbar_logo}>
						<div className={styles.logo_flex}>
							<button onClick={() => handleNavigate("/")}><img src={active === "Home" ? mylo_logo : mylo_yellow_logo} style={active === "Home" ? { backgroundColor :'#fdde42', paddingLeft: '1rem' } : { paddingLeft: '1rem' }}/></button>
							<button onClick={() => handleNavigate("/safety")}><img src={active === "Safety" ? logo_msw : logo_ms} style={active === "Safety" ? { backgroundColor :'#cf2930', marginLeft: '-1rem', paddingLeft: '1rem' } : {}}/></button>
							<button onClick={() => handleNavigate("/tradies")}><img src={active === "Tradies" ? logo_mtw : logo_mt} style={active === "Tradies" ? { backgroundColor :'#f56329', marginLeft: '-1rem', paddingLeft: '1rem' } : {}}/></button>
							<button onClick={() => handleNavigate("/home-modifications")}><img src={active === "HomeMods" ? logo_mhw : logo_mh} style={active === "HomeMods" ? { backgroundColor :'#1c75ba', marginLeft: '-1rem', paddingLeft: '1rem' } : {}}/></button>
						</div>
					</div>

					<div className={styles.topbar_items}>
						<button className={`${styles.topbar_navbtn} ${active === "Home" && styles.topbar_navbtn_active}`} onClick={() => handleNavigate("/")}><p className={`m1 inter light`}>Home</p></button>
						{/* <button className={styles.topbar_navbtn}><p className={`m1 inter light`}>Services</p></button> */}
						<button className={`${styles.topbar_navbtn} ${active === "Contact" && styles.topbar_navbtn_active}`} onClick={() => handleNavigate("/contact")}><p className={`m1 inter light`}>Contact</p></button>
						<a className={styles.topbar_callbtn} href={"https://myloportal.com.au"} target="_blank"><p className={`m1 inter medium`}>MYLO Portal</p></a>
					</div>

					<div className={styles.topbar_logo_optimised}>
						<div className={styles.logo_flex}>
							{/* <img src={mylo_logo}/> */}
							<button className={active === "Home" && styles.active_opt_logo_btn} onClick={() => handleNavigate("/")} style={active === "Home" ? {backgroundColor :'#fdde42'} : {}}><img src={active === "Home" ? mylo_logo : mylo_yellow_logo} style={active === "Home" ? { paddingLeft: '1rem' } : { paddingLeft: '1rem' }}/></button>
							<button className={active === "Safety" && styles.active_opt_logo_btn} onClick={() => handleNavigate("/safety")} style={active === "Safety" ? {backgroundColor :'#cf2930'} : {}}><img src={active === "Safety" ? logo_msw : logo_ms} style={active === "Safety" ? { marginLeft: '-1rem', paddingLeft: '1rem' } : {}}/></button>
							<button className={active === "Tradies" && styles.active_opt_logo_btn} onClick={() => handleNavigate("/tradies")} style={active === "Tradies" ? {backgroundColor :'#f56329'} : {}}><img src={active === "Tradies" ? logo_mtw : logo_mt} style={active === "Tradies" ? { marginLeft: '-1rem', paddingLeft: '1rem' } : {}}/></button>
							<button className={active === "HomeMods" && styles.active_opt_logo_btn} onClick={() => handleNavigate("/home-modifications")} style={active === "HomeMods" ? {backgroundColor :'#1c75ba'} : {}}><img src={active === "HomeMods" ? logo_mhw : logo_mh} style={active === "HomeMods" ? { marginLeft: '-1rem', paddingLeft: '1rem' } : {}}/></button>
						</div>
					</div>

					<div className={styles.topbar_items_optimised}>
						<button className={`m2 inter medium ${styles.topbar_navbtn}`} onClick={() => setShowHamburger(true)}><i className="fa-solid fa-bars-sort l2"></i></button>
					</div>
				</div>
			</div>

			{showHamburger &&
				<div className={styles.hamburger_container}>
					<button onClick={() => handleNavigate("/")} className={styles.hamburger_logo}><img src={mylo_logo}/></button>
					<button onClick={() => setShowHamburger(false)} className={styles.hamburger_close}><i className="fa-regular fa-x l3"></i></button>

					<div className={styles.hamburger_list}>
						<button className={`${styles.hamburger_navbtn} ${active === "Home" && styles.hamburger_navbtn_active}`} onClick={() => handleNavigate("/")}>
							<i className="fa-regular fa-arrow-right xl3"></i>
							<p className={`xxl3 inter bold`}>Home</p>
						</button>

						<button className={`${styles.hamburger_navbtn} ${active === "Safety" && styles.hamburger_navbtn_active}`} onClick={() => handleNavigate("/safety")}>
							<i className="fa-regular fa-arrow-right xl3"></i>
							<p className={`xxl3 inter bold`}>MYLO Safety</p>
						</button>

						<button className={`${styles.hamburger_navbtn} ${active === "Tradies" && styles.hamburger_navbtn_active}`}>
							<i className="fa-regular fa-arrow-right xl3"></i>						
							<p className={`xxl3 inter bold`}>MYLO Tradies</p>
						</button>

						<button className={`${styles.hamburger_navbtn} ${active === "HomeMods" && styles.hamburger_navbtn_active}`} onClick={() => handleNavigate("/home-modifications")}>
							<i className="fa-regular fa-arrow-right xl3"></i>						
							<p className={`xxl3 inter bold`}>MYLO Home Modifications</p>
						</button>

						<button className={`${styles.hamburger_navbtn}`} onClick={() => handleNavigate("https://myloportal.com.au")}>
							<i className="fa-regular fa-arrow-right xl3"></i>
							<p className={`xxl3 inter bold`}>MYLO Portal</p>
						</button>

						<button className={`${styles.hamburger_navbtn} ${active === "Contact" && styles.hamburger_navbtn_active}`} onClick={() => handleNavigate("/contact")}>
							<i className="fa-regular fa-arrow-right xl3"></i>
							<p className={`xxl3 inter bold`}>Contact</p>
						</button>
					</div>
				</div>
			}
		</>
	)
}

export default Topbar;